export interface TargetItem {
  id: string;
  name: string;
  description?: string;
  keywords?: string[];
}

export interface Niche extends TargetItem {
  segments: Segment[];
}

export interface Segment extends TargetItem {
  targets: Target[];
}

export interface Target extends TargetItem {
  type: string;
}

export const NICHES: Niche[] = [
  {
    id: 'servicos-domesticos',
    name: 'Serviços Domésticos e Manutenção',
    description: 'Serviços especializados para residências, condomínios e pequenos escritórios',
    segments: [
      {
        id: 'sd-limpeza',
        name: 'Limpeza, Higienização e Organização',
        description: 'Serviços de faxina, conservação e organização residencial',
        targets: [
          { id: 'diarista', name: 'Diarista / Empresa de limpeza residencial', type: 'Serviço' },
          { id: 'limpeza-pos-obra', name: 'Serviço de limpeza pós-obra', type: 'Especializado' },
          { id: 'limpeza-estofados', name: 'Limpeza de estofados / Higienização de sofás', type: 'Técnico' },
          { id: 'impermeabilizacao', name: 'Impermeabilização de sofás e tecidos', type: 'Técnico' },
          { id: 'lavanderia-tapetes', name: 'Lavanderia de tapetes e cortinas', type: 'Serviço' },
          { id: 'limpeza-vidros', name: 'Limpeza de vidros e janelas', type: 'Especializado' },
          { id: 'personal-organizer', name: 'Personal Organizer / Organizador residencial', type: 'Profissional' },
          { id: 'organizacao-mudancas', name: 'Organização de mudanças (Packing e unpacking)', type: 'Serviço' },
          { id: 'tratamento-pisos', name: 'Tratamento de pisos / Polimento de mármore / Sinteco', type: 'Técnico' },
          { id: 'limpeza-caixa-agua', name: 'Limpeza de caixa d\'água', type: 'Técnico' }
        ]
      },
      {
        id: 'sd-manutencao',
        name: 'Manutenção, Reparos e Reformas',
        description: 'Reparos gerais e pequenas reformas (Marido de Aluguel)',
        targets: [
          { id: 'marido-aluguel', name: 'Marido de aluguel / Serviços de manutenção', type: 'Multiserviço' },
          { id: 'montador-moveis', name: 'Montador de móveis', type: 'Especialista' },
          { id: 'pintor', name: 'Pintor residencial / Empresa de pintura', type: 'Especialista' },
          { id: 'papel-parede', name: 'Aplicação de papel de parede', type: 'Especialista' },
          { id: 'pedreiro', name: 'Pedreiro de pequenas reformas / Azulejista', type: 'Especialista' },
          { id: 'gesseiro', name: 'Gesseiro / Reparos em gesso e drywall', type: 'Especialista' },
          { id: 'vidraceiro', name: 'Vidraçaria residencial / Vidraceiro', type: 'Especialista' },
          { id: 'chaveiro', name: 'Chaveiro 24h / Chaveiro residencial', type: 'Especialista' },
          { id: 'peliculas', name: 'Instalação de películas / Insulfilm residencial', type: 'Técnico' },
          { id: 'adaptacao-idosos', name: 'Adaptação residencial para idosos / Acessibilidade', type: 'Especializado' }
        ]
      },
      {
        id: 'sd-utilidades',
        name: 'Elétrica, Hidráulica e Gás',
        description: 'Serviços essenciais de infraestrutura',
        targets: [
          { id: 'eletricista', name: 'Eletricista residencial / Eletricista instalador', type: 'Técnico' },
          { id: 'encanador', name: 'Encanador / Bombeiro hidráulico', type: 'Técnico' },
          { id: 'caca-vazamento', name: 'Caça-vazamentos / Localização de vazamentos', type: 'Especializado' },
          { id: 'desentupidora', name: 'Desentupidora residencial', type: 'Empresa' },
          { id: 'aquecedor-gas', name: 'Assistência técnica de aquecedor a gás', type: 'Técnico' },
          { id: 'instalacao-fogao', name: 'Instalação de fogão e cooktop', type: 'Técnico' }
        ]
      },
      {
        id: 'sd-tecnologia',
        name: 'Climatização, Segurança e Tecnologia',
        description: 'Instalações tecnológicas e climatização',
        targets: [
          { id: 'ar-condicionado-inst', name: 'Instalador de ar-condicionado', type: 'Técnico' },
          { id: 'ar-condicionado-manut', name: 'Manutenção e limpeza de ar-condicionado', type: 'Técnico' },
          { id: 'seguranca-eletronica', name: 'Empresa de segurança eletrônica / CFTV e alarmes', type: 'Empresa' },
          { id: 'fechadura-digital', name: 'Instalação de fechadura eletrônica / digital', type: 'Técnico' },
          { id: 'redes-protecao', name: 'Instalação de redes de proteção', type: 'Especializado' },
          { id: 'antenista', name: 'Antenista / Instalação de antenas de TV', type: 'Técnico' },
          { id: 'automacao', name: 'Automação residencial / Casa inteligente', type: 'Especializado' },
          { id: 'informatica', name: 'Suporte técnico de informática residencial', type: 'Técnico' },
          { id: 'portao-eletronico', name: 'Manutenção de portão eletrônico / motor', type: 'Técnico' }
        ]
      },
      {
        id: 'sd-eletro',
        name: 'Conserto de Eletrodomésticos',
        description: 'Assistência técnica de linha branca',
        targets: [
          { id: 'assistencia-lavadora', name: 'Assistência de máquina de lavar / Lava e seca', type: 'Técnico' },
          { id: 'assistencia-geladeira', name: 'Assistência de geladeira e refrigerador', type: 'Técnico' },
          { id: 'conserto-microondas', name: 'Conserto de micro-ondas e forno elétrico', type: 'Técnico' }
        ]
      },
      {
        id: 'sd-lazer',
        name: 'Áreas Externas, Jardim e Lazer',
        description: 'Serviços para lazer e áreas externas',
        targets: [
          { id: 'jardineiro', name: 'Jardineiro / Jardinagem e paisagismo', type: 'Especialista' },
          { id: 'limpeza-piscina', name: 'Limpeza de piscina / Piscineiro', type: 'Especialista' },
          { id: 'limpeza-calhas', name: 'Limpeza de calhas e telhados', type: 'Técnico' },
          { id: 'manutencao-decks', name: 'Manutenção de decks e pergolados', type: 'Especialista' },
          { id: 'manutencao-churrasqueira', name: 'Manutenção de churrasqueiras e lareiras', type: 'Especialista' },
          { id: 'energia-solar', name: 'Instalação de energia solar / Limpeza de placas', type: 'Especializado' }
        ]
      },
      {
        id: 'sd-cuidados',
        name: 'Cuidados, Assistência e Eventos',
        description: 'Serviços domiciliares e de hospitalidade',
        targets: [
          { id: 'baba', name: 'Agência de babás / Berçarista domiciliar', type: 'Apoio' },
          { id: 'cuidador-idosos', name: 'Cuidador de idosos / Home care', type: 'Apoio' },
          { id: 'dog-walker', name: 'Dog Walker / Passeador de cães', type: 'Pet Care' },
          { id: 'pet-sitter', name: 'Pet Sitter / Hotelzinho para pet em casa', type: 'Pet Care' },
          { id: 'pet-delivery', name: 'Banho e tosa delivery / Pet shop móvel', type: 'Pet Care' },
          { id: 'cozinheira', name: 'Cozinheira residencial / mensalista', type: 'Apoio' },
          { id: 'personal-chef', name: 'Personal Chef / Buffet residencial', type: 'Eventos' },
          { id: 'churrasqueiro', name: 'Churrasqueiro para eventos / domicílio', type: 'Eventos' },
          { id: 'garcom-eventos', name: 'Garçom e copeira para eventos residenciais', type: 'Eventos' },
          { id: 'recreacao-infantil', name: 'Recreação infantil domiciliar / Animador', type: 'Eventos' }
        ]
      },
      {
        id: 'sd-pragas',
        name: 'Controle de Pragas e Sanitização',
        description: 'Proteção e higienização ambiental',
        targets: [
          { id: 'dedetizadora', name: 'Dedetizadora / Controle de pragas urbanas', type: 'Empresa' },
          { id: 'desinsetizacao', name: 'Desinsetização e descupinização', type: 'Empresa' },
          { id: 'desratizacao', name: 'Desratização', type: 'Empresa' },
          { id: 'sanitizacao', name: 'Sanitização de ambientes / Desinfecção', type: 'Empresa' }
        ]
      }
    ]
  },
  {
    id: 'saude-bem-estar',
    name: 'Saúde, Bem-Estar e Estética',
    description: 'Serviços médicos, odontológicos, terapias, fitness e cuidados estéticos',
    segments: [
      {
        id: 'sb-medicina',
        name: 'Medicina e Clínicas Especializadas',
        description: 'Clínicas médicas e profissionais de saúde especializados',
        targets: [
          { id: 'clinica-medica', name: 'Clínica Médica / Consultório Geral', type: 'Saúde' },
          { id: 'pediatra', name: 'Pediatra / Clínica de Pediatria', type: 'Saúde' },
          { id: 'ginecologista', name: 'Ginecologista / Obstetra', type: 'Saúde' },
          { id: 'dermatologista', name: 'Dermatologista / Clínica Dermatológica', type: 'Saúde' },
          { id: 'cardiologista', name: 'Cardiologista / Clínica de Cardiologia', type: 'Saúde' },
          { id: 'oftalmologista', name: 'Oftalmologista / Clínica de Olhos', type: 'Saúde' },
          { id: 'ortopedista', name: 'Ortopedista / Clínica de Ortopedia', type: 'Saúde' },
          { id: 'psiquiatra', name: 'Psiquiatra / Clínica Psiquiátrica', type: 'Saúde' },
          { id: 'clinica-vacinacao', name: 'Clínica de Vacinação / Imunização', type: 'Saúde' },
          { id: 'clinica-estetica-med', name: 'Clínica de Estética Médica / Dermatologia Estética', type: 'Saúde' }
        ]
      },
      {
        id: 'sb-odontologia',
        name: 'Odontologia e Especialidades',
        description: 'Clínicas e profissionais de odontologia',
        targets: [
          { id: 'dentista-geral', name: 'Consultório Odontológico / Dentista Clínico', type: 'Odonto' },
          { id: 'clinica-odontologica', name: 'Clínica Odontológica Multidisciplinar', type: 'Odonto' },
          { id: 'ortodontista', name: 'Ortodontista / Aparelhos Dentários', type: 'Odonto' },
          { id: 'implantodontista', name: 'Implantodontista / Implantes e Próteses', type: 'Odonto' },
          { id: 'odontopediatra', name: 'Odontopediatria / Dentista Infantil', type: 'Odonto' },
          { id: 'harmonizacao-facial', name: 'Harmonização Orofacial', type: 'Odonto' }
        ]
      },
      {
        id: 'sb-fisioterapia',
        name: 'Fisioterapia, Reabilitação e Treino',
        description: 'Serviços de recuperação física e condicionamento especializado',
        targets: [
          { id: 'clinica-fisioterapia', name: 'Clínica de Fisioterapia', type: 'Saúde' },
          { id: 'quiropraxia', name: 'Quiropraxia / Quiropraxista', type: 'Saúde' },
          { id: 'osteopatia', name: 'Osteopatia', type: 'Saúde' },
          { id: 'studio-pilates', name: 'Studio de Pilates / Pilates Clínico', type: 'Bem-estar' },
          { id: 'rpg-fisioterapia', name: 'Fisioterapia RPG (Reeducação Postural Global)', type: 'Saúde' },
          { id: 'fisioterapia-pelve', name: 'Fisioterapia Pélvica / Saúde da Mulher', type: 'Saúde' }
        ]
      },
      {
        id: 'sb-psicologia',
        name: 'Saúde Mental, Terapias e Nutrição',
        description: 'Atendimento clínico focado em bem-estar mental, alimentar e comportamental',
        targets: [
          { id: 'psicologo', name: 'Psicólogo / Consultório de Psicologia', type: 'Saúde' },
          { id: 'terapeuta-casal', name: 'Terapia de Casal e Família', type: 'Saúde' },
          { id: 'psicanalista', name: 'Psicanalista', type: 'Saúde' },
          { id: 'nutricionista-clinico', name: 'Nutricionista Clínico / Funcional', type: 'Nutrição' },
          { id: 'fonoaudiologo', name: 'Fonoaudiólogo / Clínica de Fonoaudiologia', type: 'Saúde' },
          { id: 'terapeuta-ocupacional', name: 'Terapeuta Ocupacional', type: 'Saúde' }
        ]
      },
      {
        id: 'sb-fitness',
        name: 'Fitness, Academias e Esportes',
        description: 'Espaços de atividade física e saúde corporal',
        targets: [
          { id: 'academia-ginastica', name: 'Academia de Ginástica / Fitness', type: 'Esportes' },
          { id: 'studio-crossfit', name: 'Studio de Crossfit / Treinamento Funcional', type: 'Esportes' },
          { id: 'escola-natacao', name: 'Escola de Natação / Hidroginástica', type: 'Esportes' },
          { id: 'escola-artes-marciais', name: 'Escola de Artes Marciais (Jiu-Jitsu, Boxe, Muay Thai)', type: 'Esportes' },
          { id: 'escola-danca', name: 'Escola de Dança / Studio de Ballet', type: 'Esportes' },
          { id: 'studio-yoga', name: 'Studio de Yoga / Meditação', type: 'Bem-estar' },
          { id: 'personal-trainer', name: 'Personal Trainer / Consultoria Fitness', type: 'Esportes' },
          { id: 'nutricionista-esportivo', name: 'Nutricionista Esportivo', type: 'Nutrição' },
          { id: 'quadras-esportivas', name: 'Locação de Quadras (Beach Tennis, Futebol society)', type: 'Esportes' }
        ]
      },
      {
        id: 'sb-estetica',
        name: 'Estética, Beleza e Barbearia',
        description: 'Salões, clínicas de rejuvenescimento e cuidados pessoais',
        targets: [
          { id: 'salao-beleza', name: 'Salão de Beleza / Cabeleireiro', type: 'Beleza' },
          { id: 'barbearia', name: 'Barbearia / Corte Masculino', type: 'Beleza' },
          { id: 'clinica-estetica', name: 'Clínica de Estética Corporal e Facial', type: 'Beleza' },
          { id: 'designer-sobrancelha', name: 'Designer de Sobrancelhas / Cílios / Micropigmentação', type: 'Beleza' },
          { id: 'manicure-pedicure', name: 'Manicure e Pedicure / Esmalteria', type: 'Beleza' },
          { id: 'podologo', name: 'Podologia / Podólogo', type: 'Beleza' },
          { id: 'depilacao', name: 'Clínica de Depilação / Laser / Cera', type: 'Beleza' },
          { id: 'estudio-tatuagem', name: 'Estúdio de Tatuagem e Piercing', type: 'Estilo' },
          { id: 'spa-massagem', name: 'Spa Urbano / Massoterapia / Drenagem Linfática', type: 'Bem-estar' }
        ]
      }
    ]
  },
  {
    id: 'alimentacao-gastronomia',
    name: 'Alimentação, Gastronomia e Eventos',
    description: 'Bares, restaurantes, padarias, cafeterias, buffets e comércio alimentício',
    segments: [
      {
        id: 'ag-restaurantes',
        name: 'Restaurantes e Alimentação Comercial',
        description: 'Diferentes modelos e especialidades de alimentação',
        targets: [
          { id: 'restaurante-comida-caseira', name: 'Restaurante de Comida Caseira / Prato Feito', type: 'Comida' },
          { id: 'churrascaria', name: 'Churrascaria / Rodízio de Carnes', type: 'Comida' },
          { id: 'pizzaria', name: 'Pizzaria / Delivery de Pizza', type: 'Comida' },
          { id: 'hamburgueria', name: 'Hamburgueria Artesanal', type: 'Comida' },
          { id: 'comida-japonesa', name: 'Restaurante Japonês / Sushi Bar', type: 'Comida' },
          { id: 'restaurante-italiano', name: 'Restaurante Italiano / Massas', type: 'Comida' },
          { id: 'vegetariano-vegano', name: 'Restaurante Vegetariano / Vegano / Saudável', type: 'Comida' },
          { id: 'restaurante-selfservice', name: 'Restaurante Self-Service / Buffet por Quilo', type: 'Comida' },
          { id: 'galeteria', name: 'Galeteria / Frango Assado da Hora', type: 'Comida' },
          { id: 'frutos-do-mar', name: 'Restaurante de Frutos do Mar / Peixaria', type: 'Comida' }
        ]
      },
      {
        id: 'ag-cafes-lanches',
        name: 'Cafés, Padarias e Lanches Rápidos',
        description: 'Locais especializados em lanches, pães e doces',
        targets: [
          { id: 'cafeteria', name: 'Cafeteria / Café Especial', type: 'Lanche' },
          { id: 'padaria', name: 'Padaria / Panificadora de Bairro', type: 'Lanche' },
          { id: 'confeitaria', name: 'Confeitaria / Doceria / Lojas de Bolos', type: 'Lanche' },
          { id: 'pastelaria', name: 'Pastelaria / Caldo de Cana', type: 'Lanche' },
          { id: 'sorveteria', name: 'Sorveteria / Gelateria Artesanal', type: 'Lanche' },
          { id: 'acaiteria', name: 'Açaiteria / Suco Natural', type: 'Lanche' },
          { id: 'lanchonete', name: 'Lanchonete / Fast-food local', type: 'Lanche' },
          { id: 'creperia', name: 'Creperia / Tapiocaria', type: 'Lanche' }
        ]
      },
      {
        id: 'ag-vida-noturna',
        name: 'Bares, Pubs e Distribuidoras',
        description: 'Serviços noturnos, bebidas e entretenimento local',
        targets: [
          { id: 'bar-petiscos', name: 'Bar / Boteco de Petiscos / Choperia', type: 'Noite' },
          { id: 'pub-artesanal', name: 'Pub / Cervejaria Artesanal', type: 'Noite' },
          { id: 'distribuidora-bebidas', name: 'Distribuidora de Bebidas / Adega 24h', type: 'Noite' },
          { id: 'tabacaria', name: 'Tabacaria / Hookah / Lounge', type: 'Noite' },
          { id: 'casa-noturna', name: 'Casa Noturna / Balada / Show Local', type: 'Noite' }
        ]
      },
      {
        id: 'ag-buffet-festas',
        name: 'Buffets, Eventos e Cozinha Domiciliar',
        description: 'Serviços sob encomenda e atendimento de eventos',
        targets: [
          { id: 'buffet-casamento', name: 'Buffet para Casamentos e Eventos Sociais', type: 'Eventos' },
          { id: 'salao-festas-infantis', name: 'Salão de Festas / Buffet Infantil', type: 'Eventos' },
          { id: 'confeitaria-caseira', name: 'Confeiteira Caseira (Bolos decorados, docinhos)', type: 'Encomenda' },
          { id: 'marmitaria', name: 'Marmitaria / Marmitas Saudáveis / Viandas', type: 'Entrega' },
          { id: 'loja-produtos-naturais', name: 'Loja de Produtos Naturais e Suplementos', type: 'Comércio' },
          { id: 'buffet-corporativo', name: 'Buffet para Eventos Corporativos / Coffee Break', type: 'Eventos' }
        ]
      }
    ]
  },
  {
    id: 'construcao-arquitetura',
    name: 'Construção, Arquitetura e Imobiliário',
    description: 'Serviços de engenharia, arquitetura, design de interiores, imobiliárias e acabamento',
    segments: [
      {
        id: 'ca-projetos',
        name: 'Escritórios de Projetos e Consultorias',
        description: 'Desenvolvimento de projetos civis, arquitetônicos e decoração',
        targets: [
          { id: 'escritorio-arquitetura', name: 'Escritório de Arquitetura', type: 'Projetos' },
          { id: 'engenharia-civil', name: 'Escritório de Engenharia Civil / Projetos Estruturais', type: 'Projetos' },
          { id: 'designer-interiores', name: 'Designer de Interiores / Decorador', type: 'Projetos' },
          { id: 'topografia-sondagem', name: 'Serviço de Topografia / Sondagem de Solo', type: 'Projetos' },
          { id: 'paisagismo-projeto', name: 'Arquiteto Paisagista / Projetos de Paisagismo', type: 'Projetos' }
        ]
      },
      {
        id: 'ca-empreiteiras',
        name: 'Construtoras e Empreiteiras',
        description: 'Execução de obras, reformas estruturais e infraestrutura civil',
        targets: [
          { id: 'construtora-residencial', name: 'Construtora Residencial / Edificações', type: 'Obras' },
          { id: 'empreiteira-obras', name: 'Empreiteira de Obras / Reformas Gerais', type: 'Obras' },
          { id: 'marmoraria', name: 'Marmoraria / Pias, Bancadas e Revestimentos', type: 'Acabamento' },
          { id: 'serralheria', name: 'Serralheria / Portões de ferro / Grades / Estruturas', type: 'Acabamento' },
          { id: 'empresa-pintura-ind', name: 'Empresa de Pintura Industrial e Predial', type: 'Obras' },
          { id: 'reforma-fachada', name: 'Manutenção de Fachadas / Pintura Predial', type: 'Obras' },
          { id: 'instalação-pisos-ind', name: 'Instaladora de Pisos Vinílicos / Laminados / Porcelanato', type: 'Acabamento' }
        ]
      },
      {
        id: 'ca-imobiliario',
        name: 'Imobiliárias, Corretores e Condomínios',
        description: 'Venda, locação, avaliação e administração de imóveis',
        targets: [
          { id: 'imobiliaria', name: 'Imobiliária / Compra, Venda e Locação', type: 'Negócios' },
          { id: 'corretor-autonomo', name: 'Corretor de Imóveis (Autônomo)', type: 'Negócios' },
          { id: 'adm-condominios', name: 'Administradora de Condomínios', type: 'Negócios' },
          { id: 'avaliador-imoveis', name: 'Avaliador de Imóveis / Perito', type: 'Negócios' }
        ]
      },
      {
        id: 'ca-comercio',
        name: 'Lojas de Materiais de Construção e Decoração',
        description: 'Comércio varejista e atacadista de suprimentos civis e acabamento',
        targets: [
          { id: 'loja-material-construcao', name: 'Loja de Materiais de Construção de Bairro', type: 'Comércio' },
          { id: 'loja-tintas', name: 'Loja de Tintas e Complementos', type: 'Comércio' },
          { id: 'loja-iluminacao', name: 'Loja de Iluminação / Lustres / Materiais Elétricos', type: 'Comércio' },
          { id: 'revestimentos-loja', name: 'Loja de Pisos, Azulejos e Acabamentos', type: 'Comércio' },
          { id: 'loja-ferramentas', name: 'Loja de Ferramentas e Ferragens', type: 'Comércio' }
        ]
      }
    ]
  },
  {
    id: 'servicos-profissionais',
    name: 'Serviços Profissionais, Jurídicos e B2B',
    description: 'Escritórios jurídicos, contábeis, consultorias, agências e tecnologia',
    segments: [
      {
        id: 'sp-juridico',
        name: 'Escritórios de Advocacia',
        description: 'Escritórios e profissionais de advocacia especializada',
        targets: [
          { id: 'advocacia-geral', name: 'Escritório de Advocacia Geral', type: 'Jurídico' },
          { id: 'advogado-trabalhista', name: 'Advogado Trabalhista / Direito do Trabalho', type: 'Jurídico' },
          { id: 'advogado-previdenciario', name: 'Advogado Previdenciário / INSS', type: 'Jurídico' },
          { id: 'advogado-familia', name: 'Advogado de Família / Divórcio / Inventário', type: 'Jurídico' },
          { id: 'advogado-civil', name: 'Advogado Cível / Direito do Consumidor', type: 'Jurídico' },
          { id: 'advogado-tributarista', name: 'Advogado Tributarista / Direito Empresarial', type: 'Jurídico' },
          { id: 'advogado-criminalista', name: 'Advogado Criminalista / Direito Penal', type: 'Jurídico' }
        ]
      },
      {
        id: 'sp-contabilidade',
        name: 'Contabilidade, Finanças e Seguros',
        description: 'Contabilidade, planejamento tributário, seguros e assessoria financeira',
        targets: [
          { id: 'escritorio-contabilidade', name: 'Escritório de Contabilidade / Contador', type: 'Finanças' },
          { id: 'assessoria-tributaria', name: 'Consultoria Tributária / Auditoria', type: 'Finanças' },
          { id: 'corretora-seguros', name: 'Corretora de Seguros (Auto, Vida, Residencial)', type: 'Finanças' },
          { id: 'correspondente-bancario', name: 'Correspondente Bancário / Empréstimos e Financiamentos', type: 'Finanças' },
          { id: 'planejador-financeiro', name: 'Escritório de Assessoria de Investimentos', type: 'Finanças' },
          { id: 'fomento-comercial', name: 'Fomento Comercial / Factoring', type: 'Finanças' }
        ]
      },
      {
        id: 'sp-marketing',
        name: 'Marketing, Design e Produção de Conteúdo',
        description: 'Serviços de publicidade, redes sociais, vídeo e identidade de marca',
        targets: [
          { id: 'agencia-marketing-digital', name: 'Agência de Marketing Digital / SEO', type: 'Criativo' },
          { id: 'gestor-trafego-pago', name: 'Gestor de Tráfego Pago / Anúncios Online', type: 'Criativo' },
          { id: 'agencia-design', name: 'Agência de Design / Identidade Visual / Branding', type: 'Criativo' },
          { id: 'produtora-video', name: 'Produtora de Vídeo / Fotografia Corporativa', type: 'Criativo' },
          { id: 'social-media-b2b', name: 'Social Media / Gestor de Redes Sociais', type: 'Criativo' },
          { id: 'assessoria-imprensa', name: 'Assessoria de Imprensa / Relações Públicas', type: 'Criativo' }
        ]
      },
      {
        id: 'sp-ti-consultoria',
        name: 'Tecnologia da Informação e Consultorias',
        description: 'Desenvolvimento, suporte de redes, segurança digital e mentoria corporativa',
        targets: [
          { id: 'empresa-suporte-ti', name: 'Empresa de Suporte de TI / Redes e Servidores', type: 'TI' },
          { id: 'desenvolvimento-sistemas', name: 'Fábrica de Software / Desenvolvimento de Aplicativos e Sites', type: 'TI' },
          { id: 'consultoria-empresarial', name: 'Consultoria Empresarial / Gestão de Processos', type: 'Negócios' },
          { id: 'agencia-traducao', name: 'Agência de Tradução / Tradutor Juramentado', type: 'Negócios' },
          { id: 'registro-marcas', name: 'Escritório de Registro de Marcas e Patentes', type: 'Negócios' },
          { id: 'segurança-informacao', name: 'Consultoria de Segurança da Informação / LGPD', type: 'TI' }
        ]
      }
    ]
  },
  {
    id: 'educacao-ensino',
    name: 'Educação, Cultura e Ensino',
    description: 'Escolas de idiomas, colégios, cursos preparatórios, música e atividades infantis',
    segments: [
      {
        id: 'ed-regular',
        name: 'Escolas e Ensino Regular',
        description: 'Instituições de educação infantil, ensino fundamental e médio',
        targets: [
          { id: 'escola-infantil', name: 'Escola de Educação Infantil / Creche', type: 'Educação' },
          { id: 'colegio-particular', name: 'Colégio Particular / Ensino Fundamental e Médio', type: 'Educação' }
        ]
      },
      {
        id: 'ed-cursos',
        name: 'Cursos Livres e Profissionalizantes',
        description: 'Escolas de capacitação especializada, idiomas e artes',
        targets: [
          { id: 'escola-idiomas', name: 'Escola de Idiomas / Inglês / Espanhol', type: 'Cursos' },
          { id: 'escola-musica', name: 'Escola de Música / Aula de Canto, Violão, Piano', type: 'Cursos' },
          { id: 'escola-tecnologia', name: 'Escola de Informática / Programação / Robótica', type: 'Cursos' },
          { id: 'curso-preparatorio', name: 'Curso Preparatório para Concursos / Vestibulares / ENEM', type: 'Cursos' },
          { id: 'escola-gastronomia', name: 'Escola de Gastronomia / Cursos de Culinária', type: 'Cursos' },
          { id: 'escola-teatro', name: 'Escola de Teatro / Artes Cênicas', type: 'Cursos' }
        ]
      },
      {
        id: 'ed-apoio-infantil',
        name: 'Apoio Escolar e Desenvolvimento Infantil',
        description: 'Atividades extracurriculares e clínicas de psicopedagogia',
        targets: [
          { id: 'reforco-escolar', name: 'Centro de Reforço Escolar / Aulas Particulares', type: 'Educação' },
          { id: 'clinica-psicopedagogia', name: 'Clínica de Psicopedagogia / Neuropsicopedagogia', type: 'Educação' },
          { id: 'espaco-recreacao', name: 'Espaço de Recreação Infantil / Brinquedoteca', type: 'Educação' },
          { id: 'escola-futebol-infantil', name: 'Escola de Futebol Infantil / Escolinha de Esportes', type: 'Educação' }
        ]
      }
    ]
  },
  {
    id: 'varejo-comercio',
    name: 'Varejo, Lojas e Comércio Local',
    description: 'Moda, estética animal, utilidades, alimentação local, presentes e brinquedos',
    segments: [
      {
        id: 'vc-moda',
        name: 'Moda, Calçados e Acessórios',
        description: 'Lojas de vestuário e acessórios pessoais',
        targets: [
          { id: 'loja-roupa-feminina', name: 'Loja de Roupas Femininas', type: 'Moda' },
          { id: 'loja-roupa-masculina', name: 'Loja de Roupas Masculinas', type: 'Moda' },
          { id: 'loja-roupa-infantil', name: 'Loja de Roupas Infantis / Enxoval de Bebê', type: 'Moda' },
          { id: 'loja-calcados', name: 'Loja de Calçados (Sapatos, Tênis)', type: 'Moda' },
          { id: 'otica-local', name: 'Ótica / Lentes de Contato / Óculos', type: 'Varejo' },
          { id: 'joalheria-relojoaria', name: 'Joalheria e Relojoaria / Conserto de Relógios', type: 'Varejo' },
          { id: 'loja-lingerie', name: 'Loja de Lingerie e Moda Íntima', type: 'Moda' },
          { id: 'loja-multimarcas', name: 'Loja de Roupas Multimarcas / Surfwear / Streetwear', type: 'Moda' }
        ]
      },
      {
        id: 'vc-pet',
        name: 'Pet Shops e Veterinária',
        description: 'Cuidados e suprimentos para animais de estimação',
        targets: [
          { id: 'clinica-veterinaria', name: 'Clínica Veterinária / Consultório', type: 'Pet' },
          { id: 'hospital-veterinario', name: 'Hospital Veterinário 24h', type: 'Pet' },
          { id: 'pet-shop-bairro', name: 'Pet Shop de Bairro / Ração e Acessórios', type: 'Pet' },
          { id: 'banho-tosa-salao', name: 'Centro de Estética Canina / Banho e Tosa', type: 'Pet' },
          { id: 'farmacia-veterinaria', name: 'Farmácia Veterinária', type: 'Pet' },
          { id: 'adestrador-caes', name: 'Adestrador de Cães (Autônomo)', type: 'Pet' }
        ]
      },
      {
        id: 'vc-casa-lazer',
        name: 'Móveis, Decoração e Floricultura',
        description: 'Lojas para casa, lazer e jardinagem comercial',
        targets: [
          { id: 'loja-moveis-planejados', name: 'Loja de Móveis Planejados / Ambientes', type: 'Lazer' },
          { id: 'loja-decoracao', name: 'Loja de Artigos de Decoração / Presentes', type: 'Lazer' },
          { id: 'loja-colchoes', name: 'Loja de Colchões', type: 'Lazer' },
          { id: 'floricultura-local', name: 'Floricultura / Mudas e Vasos', type: 'Lazer' },
          { id: 'loja-utilidades-lar', name: 'Loja de Utilidades Domésticas / Lojas de R$ 1,99', type: 'Lazer' },
          { id: 'bazar-papelaria', name: 'Bazar e Papelaria de Bairro', type: 'Lazer' }
        ]
      },
      {
        id: 'vc-alimentos',
        name: 'Comércio de Alimentos Local',
        description: 'Produtos alimentícios frescos e conveniência',
        targets: [
          { id: 'mercado-bairro', name: 'Minimercado / Mercearia de Bairro', type: 'Alimentos' },
          { id: 'sacolao-hortifruti', name: 'Hortifrúti / Sacolão de Frutas e Verduras', type: 'Alimentos' },
          { id: 'acougue-bairro', name: 'Açougue / Casa de Carnes', type: 'Alimentos' },
          { id: 'peixaria-local', name: 'Peixaria / Frutos do Mar Frescos', type: 'Alimentos' },
          { id: 'distribuidora-agua-gas', name: 'Distribuidora de Água Mineral e Gás de Cozinha', type: 'Alimentos' },
          { id: 'loja-produtos-festas', name: 'Loja de Embalagens e Produtos para Festas', type: 'Alimentos' }
        ]
      }
    ]
  },
  {
    id: 'setor-automotivo',
    name: 'Automotivo, Transportes e Logística',
    description: 'Mecânicas, autopeças, centro de estética automotiva, autoescolas e fretes',
    segments: [
      {
        id: 'at-oficinas',
        name: 'Oficinas e Manutenção Mecânica',
        description: 'Serviços especializados de mecânica e reparação veicular',
        targets: [
          { id: 'oficina-mecanica', name: 'Oficina Mecânica Multimarcas', type: 'Mecânica' },
          { id: 'auto-eletrica', name: 'Autoelétrica / Reparo Elétrico Automotivo', type: 'Mecânica' },
          { id: 'funilaria-pintura', name: 'Oficina de Lataria e Pintura / Funilaria', type: 'Mecânica' },
          { id: 'centro-automotivo-pneus', name: 'Centro Automotivo / Alinhamento / Balanceamento / Pneus', type: 'Mecânica' },
          { id: 'oficina-ar-condicionado', name: 'Oficina de Ar-Condicionado Automotivo', type: 'Mecânica' },
          { id: 'oficina-cambio-aut', name: 'Oficina Especializada em Câmbio Automático', type: 'Mecânica' },
          { id: 'retifica-motores', name: 'Retífica de Motores', type: 'Mecânica' }
        ]
      },
      {
        id: 'at-estetica',
        name: 'Estética Automotiva e Peças',
        description: 'Limpeza, polimento, vitrificação e varejo de autopeças',
        targets: [
          { id: 'lava-rapido-local', name: 'Lava-Rápido / Car Wash', type: 'Estética' },
          { id: 'centro-estetica-veicular', name: 'Centro de Estética Automotiva / Vitrificação / Polimento', type: 'Estética' },
          { id: 'loja-autoveiculos-pecas', name: 'Loja de Autopeças / Moto Peças', type: 'Comércio' },
          { id: 'loja-pneus', name: 'Loja de Pneus Novos e Remoldados', type: 'Comércio' },
          { id: 'som-acessorios-auto', name: 'Loja de Som, Alarmes e Acessórios Automotivos', type: 'Comércio' },
          { id: 'autovidros-local', name: 'Loja de Vidros Automotivos / Autovidros', type: 'Comércio' }
        ]
      },
      {
        id: 'at-servicos',
        name: 'Serviços de Condutores e Logística',
        description: 'Autoescolas, despachantes, locadoras, guinchos e fretes',
        targets: [
          { id: 'autoescola-local', name: 'Autoescola / Centro de Formação de Condutores', type: 'Serviços' },
          { id: 'despachante-detran', name: 'Despachante Documentalista / Credenciado Detran', type: 'Serviços' },
          { id: 'locadora-veiculos', name: 'Locadora de Veículos / Aluguel de Carros', type: 'Serviços' },
          { id: 'guincho-reboque-24h', name: 'Serviço de Guincho / Reboque 24h', type: 'Serviços' },
          { id: 'fretes-mudancas-local', name: 'Fretes e Mudanças / Transportadora Local', type: 'Serviços' },
          { id: 'transporte-escolar-local', name: 'Serviço de Transporte Escolar / Van Escolar', type: 'Serviços' }
        ]
      }
    ]
  }
];

const INITIAL_NICHE_IDS = new Set<string>(NICHES.map(n => n.id));

try {
  const saved = localStorage.getItem('nyroh_custom_niches');
  if (saved) {
    const customList: Niche[] = JSON.parse(saved);
    if (Array.isArray(customList)) {
      customList.forEach(cn => {
        if (!NICHES.some(n => n.id === cn.id)) {
          NICHES.push(cn);
        }
      });
    }
  }
} catch (e) {
  console.error('Error loading custom niches:', e);
}

export function registerCustomTaxonomy(rawNiches: any[]) {
  if (!Array.isArray(rawNiches)) return;

  rawNiches.forEach((rawNiche: any) => {
    if (!rawNiche || typeof rawNiche !== 'object') return;
    
    const nicheId = rawNiche.id || rawNiche.name?.toLowerCase().replace(/[^a-z0-9]/g, '-') || `niche-${Date.now()}`;
    const nicheName = rawNiche.name || 'Novo Nicho';
    const nicheDesc = rawNiche.description || '';

    const formattedSegments: Segment[] = [];

    const segmentsList = rawNiche.segments || rawNiche.segmentos || [];
    if (Array.isArray(segmentsList)) {
      segmentsList.forEach((rawSeg: any) => {
        if (!rawSeg) return;
        const segId = rawSeg.id || rawSeg.name?.toLowerCase().replace(/[^a-z0-9]/g, '-') || `seg-${Date.now()}`;
        const segName = rawSeg.name || 'Novo Segmento';
        const segDesc = rawSeg.description || '';

        const formattedTargets: Target[] = [];
        const targetsList = rawSeg.targets || rawSeg.alvos || rawSeg.keywords || [];

        if (Array.isArray(targetsList)) {
          targetsList.forEach((rawTarget: any) => {
            if (typeof rawTarget === 'string') {
              const clean = rawTarget.trim();
              if (clean) {
                formattedTargets.push({
                  id: clean.toLowerCase().replace(/[^a-z0-9]/g, '-'),
                  name: clean,
                  type: 'Geral',
                  keywords: [clean]
                });
              }
            } else if (rawTarget && typeof rawTarget === 'object') {
              const tName = rawTarget.name || rawTarget.id || 'Alvo';
              formattedTargets.push({
                id: rawTarget.id || tName.toLowerCase().replace(/[^a-z0-9]/g, '-'),
                name: tName,
                type: rawTarget.type || 'Geral',
                description: rawTarget.description,
                keywords: Array.isArray(rawTarget.keywords) ? rawTarget.keywords : (rawTarget.termos || rawTarget.search_terms)
              });
            }
          });
        }

        formattedSegments.push({
          id: segId,
          name: segName,
          description: segDesc,
          targets: formattedTargets
        });
      });
    }

    const newNicheObj: Niche = {
      id: nicheId,
      name: nicheName,
      description: nicheDesc,
      segments: formattedSegments
    };

    const existingIndex = NICHES.findIndex(n => n.id === nicheId || n.name.toLowerCase() === nicheName.toLowerCase());
    if (existingIndex >= 0) {
      NICHES[existingIndex] = newNicheObj;
    } else {
      NICHES.push(newNicheObj);
    }
  });

  try {
    const customOnly = NICHES.filter(n => !INITIAL_NICHE_IDS.has(n.id));
    localStorage.setItem('nyroh_custom_niches', JSON.stringify(customOnly));
  } catch (e) {
    console.error('Error saving custom niches:', e);
  }

  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent('niches-updated'));
  }
}

/**
 * Curadoria inteligente de termos e variações de pesquisa para alvos estratégicos
 */
export const TARGET_CURATED_KEYWORDS: Record<string, string[]> = {
  'marido-aluguel': [
    'Marido de aluguel',
    'Serviços de manutenção residencial',
    'Pequenos reparos residenciais',
    'Faz tudo residencial',
    'Faz tudo consertos e reformas',
    'SOS Marido de aluguel',
    'Consertos e reparos gerais',
    'Instalações e manutenção predial e residencial',
    'Reparos rápidos residenciais',
    'Manutenção e pequenos consertos',
    'Serviços de bricolagem residencial',
    'Marido de aluguel 24 horas',
    'Mulher de aluguel',
    'Instalação de suportes, varal e cortinas',
    'Pequenos consertos elétricos e hidráulicos'
  ],
  'montador-moveis': [
    'Montador de móveis',
    'Montagem e desmontagem de móveis',
    'Montador de guarda-roupa e armários',
    'Montagem de móveis planejados',
    'Serviço de montador de móveis',
    'Instalação e reparo de móveis'
  ],
  'pintor': [
    'Pintor residencial',
    'Empresa de pintura predial e residencial',
    'Pintura de casas e apartamentos',
    'Pintor profissional',
    'Serviços de pintura e texturização',
    'Pintor de paredes e acabamentos'
  ],
  'papel-parede': [
    'Aplicação de papel de parede',
    'Instalador de papel de parede',
    'Colocação de papel de parede e adesivos',
    'Papel de parede e revestimentos'
  ],
  'pedreiro': [
    'Pedreiro de pequenas reformas',
    'Azulejista e colocador de pisos',
    'Pedreiro e assentador de porcelanato',
    'Reformas residenciais e alvenaria',
    'Pequenos reparos de construção'
  ],
  'gesseiro': [
    'Gesseiro',
    'Instalação de drywall e forro de gesso',
    'Sancas de gesso e molduras',
    'Reparos em gesso e paredes de gesso',
    'Gesso e acartonado'
  ],
  'vidraceiro': [
    'Vidraçaria residencial',
    'Vidraceiro',
    'Instalação de box para banheiro',
    'Espelhos e vidros sob medida',
    'Manutenção de portas e janelas de vidro'
  ],
  'chaveiro': [
    'Chaveiro 24h',
    'Chaveiro residencial',
    'Abertura de fechaduras e cópias de chaves',
    'Instalação de travas e fechaduras',
    'Socorro chaveiro'
  ],
  'peliculas': [
    'Instalação de películas residenciais',
    'Insulfilm residencial e comercial',
    'Película de proteção solar e privacidade',
    'Aplicação de insulfilm arquitetônico'
  ],
  'adaptacao-idosos': [
    'Adaptação residencial para idosos',
    'Instalação de barras de apoio e acessibilidade',
    'Adequação de banheiros e rampas acessíveis',
    'Reforma e segurança para terceira idade'
  ],
  'diarista': [
    'Diarista residencial',
    'Empresa de limpeza residencial',
    'Faxineira por dia',
    'Serviços de faxina e conservação',
    'Limpeza de apartamentos e casas'
  ],
  'limpeza-pos-obra': [
    'Limpeza pós-obra',
    'Empresa especializada em limpeza pós-obra',
    'Higienização e limpeza pesada de reforma',
    'Remoção de resíduos de construção e tintas'
  ],
  'limpeza-estofados': [
    'Limpeza de estofados',
    'Higienização de sofás',
    'Lavagem a seco de sofás e poltronas',
    'Higienização de colchões e cadeiras',
    'Limpeza profissional de estofados'
  ],
  'impermeabilizacao': [
    'Impermeabilização de sofás e tecidos',
    'Blindagem de estofados',
    'Impermeabilização de tecidos e poltronas',
    'Proteção contra líquidos e manchas em sofás'
  ],
  'eletricista': [
    'Eletricista residencial',
    'Eletricista instalador e manutenção',
    'Instalações elétricas e troca de disjuntores',
    'Instalação de chuveiro, luminárias e tomadas',
    'Eletricista 24 horas'
  ],
  'encanador': [
    'Encanador residencial',
    'Bombeiro hidráulico',
    'Desentupimento e reparo de vazamentos',
    'Conserto de torneiras, válvulas e tubulações',
    'Instalação hidráulica'
  ],
  'caca-vazamento': [
    'Caça-vazamentos residencial',
    'Localização eletrônica de vazamentos de água',
    'Geofone e detecção de vazamento oculto',
    'Laudo técnico de vazamento e conta alta de água'
  ],
  'desentupidora': [
    'Desentupidora 24 horas',
    'Desentupimento de esgoto, pia e vaso sanitário',
    'Limpeza de fossa e desobstrução de redes',
    'Hidrojateamento residencial'
  ],
  'ar-condicionado-inst': [
    'Instalador de ar-condicionado',
    'Instalação de ar-condicionado split',
    'Instalação de infraestrutura para climatização',
    'Técnico de instalação de ar-condicionado'
  ],
  'ar-condicionado-manut': [
    'Manutenção de ar-condicionado',
    'Limpeza e higienização de ar-condicionado',
    'Recarga de gás para ar-condicionado',
    'Assistência técnica de ar-condicionado residencial'
  ],
  'seguranca-eletronica': [
    'Empresa de segurança eletrônica',
    'Instalação de CFTV e câmeras de segurança',
    'Instalação e manutenção de alarmes',
    'Cerca elétrica e monitoramento residencial'
  ],
  'fechadura-digital': [
    'Instalação de fechadura eletrônica',
    'Instalação de fechadura digital e biométrica',
    'Técnico especialista em fechaduras digitais',
    'Configuração de fechadura smart e senha'
  ],
  'dedetizadora': [
    'Dedetizadora residencial',
    'Controle de pragas urbanas',
    'Dedetização de baratas, formigas e cupins',
    'Descupinização e desratização'
  ]
};

/**
 * Retorna todos os termos e palavras-chave de busca para um alvo específico
 */
// Cache dinâmico em memória / storage para termos enriquecidos via IA
const DYNAMIC_AI_KEYWORDS: Record<string, string[]> = (() => {
  try {
    const saved = localStorage.getItem('google_maps_ai_keywords');
    return saved ? JSON.parse(saved) : {};
  } catch (e) {
    return {};
  }
})();

export function saveAiTargetKeywords(targetId: string, keywords: string[]) {
  if (!targetId || !Array.isArray(keywords)) return;
  const current = DYNAMIC_AI_KEYWORDS[targetId] || [];
  const merged = Array.from(new Set([...current, ...keywords.map(k => k.trim())].filter(Boolean)));
  DYNAMIC_AI_KEYWORDS[targetId] = merged;
  try {
    localStorage.setItem('google_maps_ai_keywords', JSON.stringify(DYNAMIC_AI_KEYWORDS));
  } catch (e) {}
}

export function saveMultipleAiTargetKeywords(mapping: Record<string, string[]>) {
  Object.entries(mapping).forEach(([targetId, kws]) => {
    if (targetId && Array.isArray(kws)) {
      const current = DYNAMIC_AI_KEYWORDS[targetId] || [];
      const merged = Array.from(new Set([...current, ...kws.map(k => k.trim())].filter(Boolean)));
      DYNAMIC_AI_KEYWORDS[targetId] = merged;
    }
  });
  try {
    localStorage.setItem('google_maps_ai_keywords', JSON.stringify(DYNAMIC_AI_KEYWORDS));
  } catch (e) {}
}
export function isTargetAiEnhanced(targetId: string): boolean {
  if (!targetId) return false;
  return !!(DYNAMIC_AI_KEYWORDS[targetId] && DYNAMIC_AI_KEYWORDS[targetId].length > 0);
}

export function getTargetKeywordsCount(target: Target | TargetItem): { count: number; isAi: boolean } {
  if (!target) return { count: 0, isAi: false };
  const isAi = !!(target.id && DYNAMIC_AI_KEYWORDS[target.id] && DYNAMIC_AI_KEYWORDS[target.id].length > 0);
  const keywords = getTargetKeywords(target);
  return { count: keywords.length, isAi };
}

export function getTargetKeywords(target: Target | TargetItem): string[] {
  if (!target) return [];

  const results = new Set<string>();

  // 1. Se tem no cache da IA
  if (target.id && DYNAMIC_AI_KEYWORDS[target.id]) {
    DYNAMIC_AI_KEYWORDS[target.id].forEach(k => results.add(k));
  }

  // 2. Se o próprio alvo já possui keywords salvas
  if (target.keywords && Array.isArray(target.keywords) && target.keywords.length > 0) {
    target.keywords.forEach(k => results.add(k.trim()));
  }

  // 3. Se existe na base curada pelo ID
  if (target.id && TARGET_CURATED_KEYWORDS[target.id]) {
    TARGET_CURATED_KEYWORDS[target.id].forEach(k => results.add(k));
  }

  if (results.size > 0) {
    return Array.from(results).filter(Boolean);
  }

  // 4. Fallback inteligente a partir do nome
  const name = target.name || '';
  const cleanName = name.replace(/\([^)]*\)/g, '').trim();
  if (cleanName) results.add(cleanName);

  // Divide por barras, vírgulas, hifens ou " e "
  const parts = name
    .split(/\/|,| - | e /gi)
    .map(p => p.replace(/\([^)]*\)/g, '').trim())
    .filter(p => p.length >= 3 && !['empresa', 'serviço', 'serviços', 'residencial', 'especialista', 'geral'].includes(p.toLowerCase()));

  parts.forEach(p => results.add(p));

  // Adiciona termos naturais adicionais
  if (parts.length > 0) {
    const main = parts[0];
    if (!main.toLowerCase().startsWith('serviço') && !main.toLowerCase().startsWith('empresa')) {
      results.add(`Serviço de ${main.toLowerCase()}`);
      results.add(`Empresa de ${main.toLowerCase()}`);
    }
  }

  return Array.from(results);
}


